__turbopack_context__.v({
  "icon": "ftEiuG_icon",
  "navIcon": "ftEiuG_navIcon",
});
